import { render, staticRenderFns } from "./EzTab.vue?vue&type=template&id=32901462&"
import script from "./EzTab.vue?vue&type=script&lang=js&"
export * from "./EzTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports